export class Infusion {
  constructor() {
    this.destination_id = null;
    this.address = null;
    this.destination_type = null;
    this.player_id = null;
    this.fuel = null;
    this.defusing = null;
    this.power = null;
    this.ratio = null;
    this.commission = null;
    this.created_at = null;
    this.updated_at = null;
    this.join_infusion_minimum = null;
    this.fuel_p = null;
    this.defusing_p = null;
    this.power_p = null;
    this.owner_power_p = null;
    this.positions = [];
    this.positions_meta = null;
    this.snapshot_meta = null;
  }
}
